export const categoryList = {
    description:
        'You can search for a themes from a list. By selecting "Company list", you can check the list of companies that have technologies (patents) in the theme.',
    selectLabel: 'Filter themes',
    userSelectPlaceholder: 'Please select categories',
    inputLabel: 'Keyword',
    userInputPlaceholder: 'Please enter a keyword',
    column1: 'Category',
    column2: 'Theme Name',
    link: 'Company list',
    search: 'Analyze the selected theme',

    // テーマに所属する企業一覧
    returnListLink: 'Return to Theme List',
    theme: 'Theme',
    selected: 'Selected',
    countText: 'Number of patent applications within the theme',
    countNumber: 'patents',
    companyCountText: 'Matched',
    companyCountNumber: 'companies',
    userInputPlaceholderOfCompanyList: 'Please enter a keyword',
    searchTableSelect1: 'Company Name',
    columnOfCompanyList1: 'Company Name',
    columnOfCompanyList2: 'Registered Country',
    columnOfCompanyList9: 'Industry Classification (NACE)',
    columnOfCompanyList3: 'Patent Ownership Ratio',
    columnOfCompanyList4: 'Number of Patent Applications',
    columnOfCompanyList5: 'Number of Forward Citations',
    columnOfCompanyList6: 'Revenue [m USD]',
    columnOfCompanyList7: 'Minority Investment Amount [m JPY]',
    columnOfCompanyList8: 'Startup',
    searchOfCompanyList: 'Analyze this theme'
}
